export default "__VITE_ASSET__3782b33c__"